"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_uuid = void 0;
const uuid_1 = require("uuid");
exports.SHu_uuid = {
    Random: {
        CreateOne: (gibberish) => (0, uuid_1.v5)(gibberish + (0, uuid_1.v4)(), (0, uuid_1.v1)()),
    },
    Static: {
        StringToUUID: (address) => (0, uuid_1.v5)(address, "1b671a64-40d5-491e-99b0-da01ff1f3341"),
    },
    checkValid: (uuid) => /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi.test(uuid),
};
